import LeaderboardTable from './LeaderboardTable';
export default LeaderboardTable;
